<template>
  <div
    class="tw-bg-purple-50 d-flex flex-column justify-center tw-text-gray-900 tw-text-center tw-pt-20"
  >
    <v-img
      :lazy-src="image"
      height="10rem"
      width="10rem"
      contain
      :src="image"
      class="my-0 mx-auto flex-grow-0"
    />
    <Typography variant="headline-5" class="tw-mt-6">
      {{ text }}
    </Typography>
    <Typography variant="body-1" class="tw-mt-4">
      {{ subtext }}
    </Typography>
  </div>
</template>

<script>
import Typography from '@/components/v3/base/Typography';

export default {
  components: {
    Typography,
  },

  props: {
    image: String,
    text: String,
    subtext: String,
  },
};
</script>
